import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Text from '../../Global/Text';

// Utils
import { actionHandler } from '../../../utilities/form/formUtils';

class SnackBar extends Component {
  render() {
    const {
      desc,
      label,
      actions,
      dispatch,
      values,
      setValues,
    } = this.props;
    const bannerClass = classNames({
      'is-hidden': values.hidePopUp === null,
      'success success-show': values.hidePopUp,
      'success success-hide': !values.hidePopUp && values.hidePopUp !== null,
    });
    return (
      <div className={bannerClass}>
        <div className="confirm">
          <div className="confirm-block">
            <Text value={desc} component="span" />
            <button
              type='button'
              className='snackBar-button'
              onClick={e => actionHandler(actions, null, e, dispatch, values, setValues)}
            >
              <Text value={label} />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SnackBar;

SnackBar.defaultProps = {
  desc: '',
  label: '',
  actions: [],
  values: null,
};

SnackBar.propTypes = {
  desc: PropTypes.string,
  label: PropTypes.string,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object,
  setValues: PropTypes.func.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Steps/General/SnackBar.jsx